import { createSlice } from "@reduxjs/toolkit";
import { JoinUsSubmitApi, CompleteNMMRegistrationApi, CompleteApplicationWithNMMApi } from "../api/JoinUsApi";

const initialState = {
  applicationData: {},
  tempApplicationData: null,
  successMessage: null,
  loading: false,
  error: null,
  otpLoading: false,
  otpError: null,
  nmmCompleted: false,
  requiresOtpVerification: false,
  nmmEmail: null,
};

const JoinUsSlice = createSlice({
  name: "JoinUsSlice",
  initialState,
  reducers: {
    resetJoinUs: (state) => {
      state.applicationData = {};
      state.successMessage = null;
      state.error = null;
      state.loading = false;
      state.otpLoading = false;
      state.otpError = null;
      state.nmmCompleted = false;
    },
    clearOtpError: (state) => {
      state.otpError = null;
    },
    resetNMMStatus: (state) => {
      state.nmmCompleted = false;
      state.otpError = null;
      state.otpLoading = false;
      state.requiresOtpVerification = false;
      state.tempApplicationData = null;
      state.nmmEmail = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(JoinUsSubmitApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(JoinUsSubmitApi.fulfilled, (state, action) => {
        state.loading = false;
        
        // Since email_exists is now treated as an error,
        // all successful responses require OTP verification
        if (action.payload.requires_otp_verification) {
          state.tempApplicationData = action.payload.data.temp_application;
          state.nmmEmail = action.payload.data.email;
          state.requiresOtpVerification = true;
        } else {
          // Fallback case (shouldn't normally happen)
          state.applicationData = action.payload.data;
          state.successMessage = action.payload.message;
        }
      })
      .addCase(JoinUsSubmitApi.rejected, (state, action) => {
        state.loading = false;
        
        // Extract error message from the payload (which now has better error handling)
        const errorPayload = action.payload;
        console.log("JoinUsSubmitApi rejected payload:", errorPayload);
        
        if (errorPayload?.message) {
          state.error = errorPayload.message;
        } else {
          state.error = "Submission failed. Please try again.";
        }
      })
      .addCase(CompleteNMMRegistrationApi.pending, (state) => {
        state.otpLoading = true;
        state.otpError = null;
      })
      .addCase(CompleteNMMRegistrationApi.fulfilled, (state, action) => {
        state.otpLoading = false;
        state.nmmCompleted = true;
        state.otpError = null;
      })
      .addCase(CompleteNMMRegistrationApi.rejected, (state, action) => {
        state.otpLoading = false;
        // Get error message from different possible sources
        const errorMessage = action.error.message || 
                            action.payload?.message || 
                            action.payload?.error?.message ||
                            "OTP verification failed. Please try again.";
        state.otpError = errorMessage;
      })
      .addCase(CompleteApplicationWithNMMApi.pending, (state) => {
        state.otpLoading = true;
        state.otpError = null;
      })
      .addCase(CompleteApplicationWithNMMApi.fulfilled, (state, action) => {
        state.otpLoading = false;
        state.nmmCompleted = true;
        state.applicationData = action.payload.data;
        state.successMessage = action.payload.message;
        state.requiresOtpVerification = false;
        state.tempApplicationData = null;
        state.otpError = null;
      })
      .addCase(CompleteApplicationWithNMMApi.rejected, (state, action) => {
        state.otpLoading = false;
        
        // Extract error message from the payload (which now has better error handling)
        const errorPayload = action.payload;
        console.log("CompleteApplicationWithNMMApi rejected payload:", errorPayload);
        
        if (errorPayload?.message) {
          state.otpError = errorPayload.message;
        } else {
          state.otpError = "Application completion failed. Please try again.";
        }
      });
  },
});

export const { resetJoinUs, clearOtpError, resetNMMStatus } = JoinUsSlice.actions;
export default JoinUsSlice.reducer;
